import "./App.css";
import Footer from "./Components/footer/footer";
import Header from "./Components/header/header";


function App() {
  return (
    <div>
       <Header/>
       <Footer/>
    </div>
  );
}

export default App;
